class ShopByRoom extends HTMLElement {
    constructor() {
      super();
      this.activeIndex = -1;
      this.isMobile = window.matchMedia('(max-width: 900px)').matches;
      this.handleScroll = this.handleScroll.bind(this);
    }
  
    connectedCallback() {
      this.section = this.querySelector('.shop-by-room');
      if (!this.section) return;
  
      this.tabs = this.section.querySelectorAll('.shop-by-room__room-btn');
      this.panels = this.section.querySelectorAll('.shop-by-room__room-panel');
      this.leftImages = this.section.querySelectorAll('.shop-by-room__left-image');
  
      if (this.isMobile) {
        window.addEventListener('scroll', this.handleScroll, { passive: true });
      } else {
        this.tabs.forEach((tab, idx) => {
          tab.addEventListener('mouseenter', () => this.activateTab(idx));
        });
      }
  
      // Initially activate first tab
      this.activateTab(0);
    }
  
    disconnectedCallback() {
      if (this.isMobile) {
        window.removeEventListener('scroll', this.handleScroll);
      }
    }
  
    handleScroll() {
      const sectionTop = this.section.offsetTop;
      const sectionHeight = this.section.offsetHeight;
      const scrollY = window.scrollY + window.innerHeight / 2;
    
      // Prevent premature triggering
      if (scrollY < sectionTop) {
        if (this.activeIndex !== 0) this.activateTab(0);
        return;
      }
    
      const totalScrollRange = sectionHeight;
      const scrollOffset = scrollY - sectionTop;
      const sectionPerPanel = totalScrollRange / this.panels.length;
      const rawIndex = Math.floor(scrollOffset / sectionPerPanel);
      const newIndex = Math.min(rawIndex, this.panels.length - 1); // avoid overflow
    
      if (newIndex !== this.activeIndex) {
        this.activateTab(newIndex);
      }
    }  
  
    activateTab(idx) {
      this.activeIndex = idx;
  
      this.tabs.forEach((tab, i) => {
        const isActive = i === idx;
        tab.classList.toggle('active', isActive);
        tab.setAttribute('aria-selected', isActive);
        tab.setAttribute('tabindex', isActive ? '0' : '-1');
      });
  
      this.panels.forEach((panel, i) => {
        const isActive = i === idx;
        panel.classList.toggle('active', isActive);
      });
  
      this.leftImages.forEach((img, i) => {
        const isActive = i === idx;
        img.classList.toggle('active', isActive);
      });
    }
  }
  
  customElements.define('shop-by-room-component', ShopByRoom);
  